module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1000.530c2c80.svg";